var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,18H5v2H3L2,19V1L3,0H17l1,1V3H16V2H4ZM22,5V23l-1,1H7L6,23V5L7,4H21ZM20,6H8V22H20ZM18,9H10v2h8Zm0,4H10v2h8Zm-4,4H10v2h4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocuments);
export default __webpack_public_path__ + "static/1768397567/media/icon-documents.fd1d90e726febd15751a29f235a6ed33.svg";
export { ForwardRef as ReactComponent };